import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { User, UserProcess, UserProcessStatus } from '@interfaces';
import { Observable } from 'rxjs';
import { PurchaseTags } from '@shared/purchase-tags/service-level-tag.component';
import { WorkPermitApplication } from '@core/foreigner-applications-utils';
import { MyWorkPermit } from '../../work-permits/work-permits.interfaces';

// This component intentionally does not use a component stylesheet.
// Global application-selector styles live in: /src/scss/application-selector-overrides.scss
@Component({
  selector: 'app-application-selector',
  templateUrl: './application-selector.component.html',
  standalone: false,
})
export class ApplicationSelectorComponent implements OnChanges {
  @Input() myProcesses$: Observable<UserProcess[]>;
  @Input() myProcess: UserProcess;
  @Input() myWorkPermits: MyWorkPermit[] | null = null;
  @Input() selectedWorkPermitId: string | null = null;
  @Input() addingNewProcess: null | { id: string } = null;
  @Input() myself$: Observable<User>;

  @Output() applicationChanged: EventEmitter<any> = new EventEmitter<any>();

  protected readonly PurchaseTags = PurchaseTags;
  protected readonly UserProcessStatus = UserProcessStatus;

  public selectedValue: UserProcess | WorkPermitApplication;
  public selectedWorkPermit: MyWorkPermit | null = null;

  constructor() {}

  public ngOnChanges(): void {
    this.selectedWorkPermit = this.myWorkPermits?.find(({ id }) => id === this.selectedWorkPermitId) ?? null;
    this.selectedValue = this.selectedWorkPermitId
      ? { id: this.selectedWorkPermitId, isWorkPermit: true }
      : this.myProcess;
  }

  public compareSelectedApplication(app1: UserProcess, app2: UserProcess): boolean {
    return app1?.id === app2?.id;
  }
}
